import React from 'react';
import { StyleSheet, View } from 'react-native';
import { rem } from 'design-system';
import Text from 'design-system/Text';
const Li = ({ desc }) => (<View style={styles.container}>
    <View style={styles.dotContainer}>
      <Text TextThin-14 Secondary>
        •
      </Text>
    </View>
    <Text TextThin-14 Secondary style={styles.desc}>
      {desc}
    </Text>
  </View>);
export default Li;
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        paddingVertical: rem(4),
    },
    dotContainer: {
        paddingHorizontal: rem(8),
    },
    desc: {
        flex: 1,
        flexShrink: 1,
    },
});
